<template>
  <div id="app">
    <div class="web_container">
      <div class="body_container">
        <img class="location_img" src="../assets/footer/ico_location.png" />
        <span class="location_dec">杭州市余杭区舒心路359号正元智慧大厦B座1002室</span>
        <img class="mailbox_img" src="../assets/footer/ico_mailbox.png" />
        <span class="mailbox_dec">business@everglamming.com（业务合作）<br />hr@everglamming.com（人事招聘）</span>
        <span class="cropyright_dec">Copyright @ 杭州慧日永明文化传播有限公司 2017 <span @click="go">浙ICP备2020043054号-1</span><br />公安机关备案号 33011002013506
          &nbsp;&nbsp;&nbsp;&nbsp; 电话 0571—88613717</span>
      </div>
    </div>

    <div class="phone_container">
      <div class="phone_body_container">
        <img class="phone_location_img" src="../assets/footer/ico_location.png" />
        <span class="phone_location_dec">杭州市余杭区<br/>舒心路359号正元智慧大厦B座1002室</span>
        <img class="phone_mailbox_img" src="../assets/footer/ico_mailbox.png" />
        <span class="phone_mailbox_dec">business@everglamming.com（业务合作）<br />hr@everglamming.com（人事招聘）</span>
        <span class="phone_cropyright_dec">Copyright @ 杭州慧日永明文化传播有限公司<br/> 2017 <span @click="go">浙ICP备2020043054号</span><br />公安机关备案号 33011002013506
          <br/>电话 0571—88613717</span>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'footer',
    data() {
      return {
        msg: 'footer'
      }
    },
    methods:{
      go(){
        var url = "http://beian.miit.gov.cn"
      	window.open(url,'_blank')
      },
    }
  }
</script>

<style scoped>
  .web_container{
    width:100%;
  }
  .body_container {
    background-size: 100%;
    width: 100%;
    background-image: url(../assets/footer/bg_footer.png);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .location_img {
    width: 0.833333vw;
    height: 0.833333vw;
    margin-top: 2.916666vw;
  }

  .location_dec {
    margin-top: 0.520833vw;
    font-size: 0.833333vw;
    font-family: 'PingFang SC';
    color: #4E4D4D;
  }

  .mailbox_img {
    width: 0.833333vw;
    height: 0.833333vw;
    margin-top: 0.520833vw;
  }

  .mailbox_dec {
    margin-top: 0.520833vw;
    font-size: 0.833333vw;
    font-family: 'PingFang SC';
    color: #4E4D4D;
    text-align: center;
  }

  .cropyright_dec {
    margin-top: 1.875vw;
    font-size: 0.833333vw;
    font-family: 'PingFang SC';
    color: #4E4D4D;
    text-align: center;
    margin-bottom: 2.916666vw;
  }

  .phone_container{
    width:100%;
  }

  .phone_body_container {
    background-size: 100%;
    width: 100%;
    background-image: url(../assets/footer/phone_bg_footer.png);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone_location_img {
    width: 3.733333vw;
    height: 3.733333vw;
    margin-top:8.533333vw;
  }

  .phone_location_dec {
    margin-top: 1.333333vw;
    font-size: 3.733333vw;
    font-family: 'PingFang SC';
    color: #4E4D4D;
	  text-align: center;
  }

  .phone_mailbox_img {
    width: 4.266666vw;
    height: 4.266666vw;
    margin-top: 6.4vw;
  }

  .phone_mailbox_dec {
    margin-top: 1.333333vw;
    font-size: 3.733333vw;
    font-family: 'PingFang SC';
    color: #4E4D4D;
    text-align: center;
  }

  .phone_cropyright_dec {
    margin-top: 6.4vw;
    font-size: 3.733333vw;
    font-family: 'PingFang SC';
    color: #4E4D4D;
    text-align: center;
    margin-bottom: 8vw;
  }

</style>



// WEBPACK FOOTER //
// src/components/footers.vue